import { useEffect, useState } from 'react';
import { ApiError } from '../api';
import { navigate } from '../router';
import { togetherApi } from '../together';

/** Samen kijken: met een code meedoen met iemand die al kijkt. */
export function TogetherJoin({ initial }: { initial: string }) {
  const [code, setCode] = useState(initial);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const join = async (c: string) => {
    setBusy(true);
    setError(null);
    try {
      const room = await togetherApi.room(c);
      navigate(`/play/${room.ratingKey}?together=${room.code}`);
    } catch (e) {
      setError(e instanceof ApiError && e.message !== e.code ? e.message : 'Deze code werkt niet (meer).');
    } finally {
      setBusy(false);
    }
  };

  useEffect(() => {
    if (initial.length === 4) void join(initial);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className="page center-screen together-page">
      <h1>Samen kijken</h1>
      <p className="muted" style={{ maxWidth: '44ch', textAlign: 'center' }}>
        Kijkt iemand anders al? Vraag de code van 4 letters (in hun player bij "Samen kijken") en vul hem hier in.
        Afspelen, pauzeren en spoelen gaat dan bij jullie allebei tegelijk.
      </p>
      <form onSubmit={(e) => { e.preventDefault(); if (code.length === 4) void join(code); }} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14 }}>
        <input className="pin-input together-code" value={code} maxLength={4} autoFocus autoComplete="off" aria-label="Code" onChange={(e) => setCode(e.target.value.toUpperCase().replace(/[^A-Z]/g, ''))} />
        {error && <p className="error" role="alert">{error}</p>}
        <button className="btn btn-primary" disabled={busy || code.length !== 4}>{busy ? 'Bezig…' : 'Meedoen'}</button>
      </form>
      <p className="subtle hint" style={{ maxWidth: '44ch', textAlign: 'center' }}>Zelf een kamer starten doe je in de player: knop "Samen kijken".</p>
    </main>
  );
}
